export const ADD_MODAL = 'CollateralAddModal'
export const CLIENT_SEARCH_MODAL = 'CollateralFormClientSearchModal'
export const CLIENT_SEARCH_NAME = 'CollateralFormClientSearch'
export const CLIENT_CONFIRM_MODAL = 'AccountFormClientConfirmModal'
export const COLLATERAL_FORM_NAME = 'collateralAddInNavigation'
